import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'GESTAO_VM_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function initForm(registro = {}) {
    return [
        initialize('gestaoVMForm', registro)
    ];
}

export function setFiltro(filtro = {}) {
    return {
        type: 'GESTAO_VM_FILTRO',
        payload: {
			filtro: filtro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'GESTAO_VM_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function getLista() {
	return (dispatch, getState) => {
		
		dispatch({
			type: 'GESTAO_VM_LISTADO',
			payload: { data: [] }
		});

		// dispatch(setAguardando(true));

		const filtro = getState().gestaoVM.filtro;

    	axios.get(`${consts.API_URL}/gestaoVMData?ano=${filtro.ano || null}&mes=${filtro.mes || null}&semana=${filtro.semana || null}`).then(resp => {
			dispatch({
		        type: 'GESTAO_VM_LISTADO',
		        payload: resp
		    });
			// dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			// dispatch(setAguardando(false));
		});
	}
}

export function finalizar(registro) {
	return async (dispatch, getState) => {
		await axios.post(`${consts.API_URL}/gestaoVMData/finalizar`, {
			...registro,
			id_usuario_inclusao: getState().auth.usuario.id,
			id_usuario_alteracao: getState().auth.usuario.id
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
	};
}

export function excluir(registro, evento) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/gestaoVM?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaMotorista() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/motorista/listarSelect?contrato_ativo=true`)
		.then(resp => {			
			dispatch({
				type: 'GESTAO_VM_MOTORISTA_SELECT_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function alterrarMotoristaVencimento(registro) {
	return async (dispatch, getState) => {
		await axios.put(`${consts.API_URL}/motorista/vencimentos`, {
			...registro,
			id_usuario_alteracao: getState().auth.usuario.id
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getListaMotoristaVencimento(registro.data_gestao));
		}).catch(e => {
			setErroAPI(e);
		});
	};
}

export function getListaPlaca() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/gestaoVMData/listarPlacas`)
		.then(resp => {			
			dispatch({
				type: 'GESTAO_VM_PLACA_SELECT_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaMotoristaVencimento(data) {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/gestaoVMData/listarMotoristaVencimento?data_gestao=${data}`)
		.then(resp => {			
			dispatch({
				type: 'GESTAO_VM_MOTORISTA_VENCIMENTO_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaTipo() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/gestaoVMTipo/listarSelect`)
		.then(resp => {
			dispatch({
				type: 'GESTAO_VM_TIPO_SELECT_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaEstado() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/gestaoVMEstado/listarSelect`)
		.then(resp => {
			dispatch({
				type: 'GESTAO_VM_ESTADO_SELECT_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

//Veículo

export function getListaGestaoVeiculo(data) {
	return (dispatch, getState) => {
		
		// dispatch(setAguardando(true));

    	axios.get(`${consts.API_URL}/gestaoVMVeiculo?data_gestao=${data}`).then(resp => {
			dispatch({
		        type: 'GESTAO_VM_GESTAO_VEICULO_LISTADO',
		        payload: resp
		    });
			// dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			// dispatch(setAguardando(false));
		});
	}
}

export function salvarGestaoVeiculo(registro) {
	return async (dispatch, getState) => {		
		await axios.post(`${consts.API_URL}/gestaoVMVeiculo`, {
			...registro,
			id_usuario_inclusao: getState().auth.usuario.id,
			id_usuario_alteracao: getState().auth.usuario.id
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getListaGestaoVeiculo(registro.data_gestao));
			dispatch(getListaGestaoMotorista(registro.data_gestao));
		}).catch(e => {
			setErroAPI(e);
		});
	};
}

//Motorista

export function getListaGestaoMotorista(data) {
	return (dispatch, getState) => {
	
		// dispatch(setAguardando(true));

    	axios.get(`${consts.API_URL}/gestaoVMMotorista?data_gestao=${data}`).then(resp => {
			dispatch({
		        type: 'GESTAO_VM_GESTAO_MOTORISTA_LISTADO',
		        payload: resp
		    });
			// dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			// dispatch(setAguardando(false));
		});
	}
}

export function salvarGestaoMotorista(registro) {
	return async (dispatch, getState) => {
		await axios.post(`${consts.API_URL}/gestaoVMMotorista`, {
			...registro,
			id_usuario_inclusao: getState().auth.usuario.id,
			id_usuario_alteracao: getState().auth.usuario.id
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getListaGestaoMotorista(registro.data_gestao));
			dispatch(getListaGestaoVeiculo(registro.data_gestao));
		}).catch(e => {
			setErroAPI(e);
		});
	};
}